module.exports = __webpack_public_path__ + "img/cooperation18.5eb1b476.png";